import VXETable from 'vxe-table'
import { tablePageConfig } from '@/public/params/global.js'

/**
 * 修改默认配置
 */
VXETable.setup({
  authId: 'xd4tkwp2ua4jjp2c', // Auth ID 在官网登录查看
  table: {
    // 表格的全局参数
    size: 'mini',
    border: true,
    resizable: true,
    showOverflow: 'tooltip',
    showHeaderOverflow: false,
    highlightCurrentRow: true,
    highlightHoverRow: true,
    validFullData: 'obsolete',
    keepSource: true,
    rowId: '_XID',
    tooltipConfig: {
      theme: 'light',
      enterable: false,
    },
    clipConfig: {
      // 重写单元格粘贴赋值的方法，从剪贴板赋值到单元格
      pasteMethod: ({ row, column, cellValue }) => {
        if (column.editRender) {
          if (
            ['input', '$input'].includes(column.editRender.name) &&
            (!column.editRender.attrs || !column.editRender.attrs.disabled)
          ) {
            row[column.property] = cellValue
          }
        }
      },
    },
    // 导出设置
    exportConfig: {
      // 默认选中类型
      type: 'xlsx',
      // 自定义类型
      types: ['xlsx', 'csv', 'html', 'xml', 'txt'],
      // isPrint: true,
      // modes: ['current', 'selected']
    },
    scrollX: {
      gt: 50,
    },
    scrollY: {
      gt: 50,
    },
  },
  grid: {
    size: 'mini',
    pager: {
      perfect: true,
      pageSize: tablePageConfig.defaultPageSize,
      align: 'left',
      pageSizes: tablePageConfig.pageSizes,
      layouts: [
        'Sizes',
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'FullJump',
        'Total',
      ],
    },
  }
})
